import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { Sc3ErrorMessageListCheck, Sc3ErrorMessageListInitialState } from './sc3-message-checker.actions';
import { Sc3MessageCheckerService } from './sc3-message-checker.service';
import { DataQualityErrorMessage, MessageCheckerStateModel } from '../models/message-checker.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

const initialState: MessageCheckerStateModel = {
  errorMessages: null,
  loaded: false,
};

@State<MessageCheckerStateModel>({
  name: 'sc3MessageChecker',
  defaults: initialState,
})
@Injectable()
export class Sc3MessageCheckerState {
  constructor(
    private sc3MessageCheckerService: Sc3MessageCheckerService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: MessageCheckerStateModel): MessageCheckerStateModel {
    return state;
  }
  @Selector()
  static getSc3ErrorMessageList(state: MessageCheckerStateModel): DataQualityErrorMessage {
    return state.errorMessages;
  }
  @Selector()
  static getLoaded(state: MessageCheckerStateModel): boolean {
    return state.loaded;
  }

  @Action(Sc3ErrorMessageListCheck)
  checkSc3ErrorMessageList(
    ctx: StateContext<MessageCheckerStateModel>,
    { payload }: Sc3ErrorMessageListCheck,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.sc3MessageCheckerService.checkSc3Message(payload).pipe(
      take(1),
      map((errorMessages: DataQualityErrorMessage) => {
        ctx.patchState({ errorMessages, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(Sc3ErrorMessageListInitialState)
  setInitialState(ctx: StateContext<MessageCheckerStateModel>): void {
    ctx.setState(initialState);
  }
}
